import React, { useCallback } from 'react';
import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { useToggle } from 'Shared/utils/hooks';
import ConfirmModal from 'Shared/components/ConfirmModal/ConfirmModal';

type Props = {
  errorsDisableSubmit?: Function;
  onCancel: Function;
  onDelete: Function;
};

export default function GoalsButtonsArea({ errorsDisableSubmit, onDelete, onCancel }: Props) {
  const [isConfirmModalOpen, isConfirmModalOpenToggle] = useToggle(false);
  const [isDeleteProcessing, toggleDeleteProcessing] = useToggle(false);

  const handleCancelClick = useCallback(() => {
    onCancel();
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    toggleDeleteProcessing();
    await onDelete().finally(() => {
      toggleDeleteProcessing();
    });
  }, [onDelete]);

  const { submitting, errors } = useFormState();
  const errorsExist = errorsDisableSubmit
    ? errorsDisableSubmit(errors)
    : !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <div className="d-flex justify-content-between w-100 mt-5">
      <WpButton size="md" variant="secondary" color="danger" onClick={isConfirmModalOpenToggle}>
        Delete goal
      </WpButton>
      <WpButtonGroup>
        <WpButton variant="tertiary" onClick={handleCancelClick}>
          Cancel
        </WpButton>
        <WpButton size="md" btnType="submit" disabled={errorsExist} loading={submitting}>
          Update Goal
        </WpButton>
      </WpButtonGroup>
      {isConfirmModalOpen ? (
        <ConfirmModal
          message="Are you sure you want to delete this goal?"
          isOpen
          isProcessing={isDeleteProcessing}
          onToggle={isConfirmModalOpenToggle}
          onConfirmClick={handleConfirmDelete}
          confirmButtonLabel="Delete"
        />
      ) : null}
    </div>
  );
}
